module.exports = __webpack_public_path__ + "static/bumper_sticker_final.fba91ccd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/SongModal/bumper_sticker_final.jpg
// module id = 488
// module chunks = 35783957827783